import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import axios from "axios";

var consts = require('./config');


Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/status/:_id",
      name: "status",
      component: () => import("./views/Status.vue")
    },
    {
      path: "/j",
      name: "j",
      component: () => import("./views/Jouez.vue")
    },
    {
      path: "/iframe",
      name: "iframe",
      component: () => import("./views/Iframe.vue")
    },
    {
      path: "/update/:id/:submissionId/:secu",
      name: "update",
      component: () => import("./views/Update.vue")
    },
    {
      path: "/whaooform/:submissionId",
      name: "updateWhaoo",
      component: () => import("./views/WhaooForm.vue")
    },
    {
      path: "/informations",
      name: "informations",
      component: () => import("./views/Informations.vue")
    },   
    {
      path: "/whaoo",
      name: "whaoo",
      component: () => import("./views/Whaoo.vue")
    },
    {
      path: "/old",
      name: "jouezOld",
      component: () => import("./views/JouezOld.vue")
    },
    {
      path: "/form/:id",
      name: "jouez",
      component: () => import("./views/Form.vue")
    },
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue")
    },
    {
      path: "/done",
      name: "done",
      component: () => import("./views/Done.vue")
    },   
    {
      path: "/finish",
      name: "finish",
      component: () => import("./views/Finish.vue")
    }
  ]
});

export default router;

function getData() {
  return axios.get(
    consts.SERVER_URL+consts.GAME_ID
  );
}

let read = 0;
router.beforeEach(async (to, from, next) => {
  // var result = await getData();
  // var gameData = result.data;

  // localStorage.setItem("gameData", JSON.stringify(gameData));

  // if (gameData.tracking) {
  //   Vue.use(VueAnalytics, {
  //     id: gameData.tracking,
  //     checkDuplicatedScript: true
  //   });
  // }

  // var uri = window.location.href;
  // var staging = uri.match(/staging/g);
  // var local = uri.match(/localhost/g);
  // var prodheroku = uri.match(/herokuapp/g);

  // if (local == null && staging == null) {
  //   if (prodheroku != null) {
  //     var url = "https://" + gameData.domaine;
  //     window.location = url;
  //   }
  // }
  next();
});
